import { z } from 'zod';

// ─── Schéma erreur NestJS ─────────────────────────────────────────
const apiErrorSchema = z.object({
  statusCode: z.number(),
  message: z.union([z.string(), z.array(z.string())]),
  error: z.string().optional(),
});

function extractErrorMessage(data: unknown, status: number): string {
  const parsed = apiErrorSchema.safeParse(data);
  if (!parsed.success) return `Erreur serveur (${status})`;

  const { message } = parsed.data;
  return Array.isArray(message) ? message.join('\n') : message;
}

// ─── Schéma wrapper TransformInterceptor ──────────────────────────
const wrappedSchema = z.object({
  success: z.literal(true),
  data: z.unknown(),
});

/**
 * Unwrap le wrapper { success, data } de ton TransformInterceptor.
 * Si la réponse n'est pas wrappée, retourne telle quelle.
 */
function unwrapResponse(raw: unknown): unknown {
  const wrapped = wrappedSchema.safeParse(raw);
  return wrapped.success ? wrapped.data.data : raw;
}

/**
 * fetch + JSON parse + unwrap TransformInterceptor + Zod validation.
 */
export async function fetchJson<T>(url: string, init: RequestInit, schema: z.ZodType<T>): Promise<T> {
  const res = await fetch(url, init);
  const raw: unknown = await res.json();

  if (!res.ok) {
    throw new Error(extractErrorMessage(raw, res.status));
  }

  const data = unwrapResponse(raw);

  const parsed = schema.safeParse(data);
  if (!parsed.success) {
    throw new Error('Réponse API invalide');
  }

  return parsed.data;
}
